export default "__VITE_ASSET__9ad7c47d__"